export const quizMixin = {
    data() {
        return {
            selectedOptions: [],
            showQuestionnaire: false,
            step: 0,
        };
    },
    computed: {
        trafficSource() {
            return (
                document.querySelector('#main-ts')?.getAttribute('data-ts') ||
                this.$globalState.trafficSource
            );
        },
        bulletPointStyle() {
            const categoryPage = this.$globalConstants.components.CategoryPage;
            const partnerRowBeta =
                this.$globalConstants.components.PartnerRowBeta;

            if (
                categoryPage.partnerRowType === 'PartnerRowBeta' &&
                partnerRowBeta.expandableSectionBulletPointIconType
            ) {
                const iconUrl = this.resizeImage(
                    'img/icons/rating-icons/' +
                        partnerRowBeta.expandableSectionBulletPointIconType +
                        '.svg',
                    12,
                    12,
                    60,
                    partnerRowBeta.expandableSectionBulletPointIconColor
                );
                return { '--bulletPoints': `url('${iconUrl}')` };
            }

            return {};
        },
    },
    methods: {
        clickOutUrl(type) {
            return this.goto(this.result.partner.cp_id, null, type);
        },
    },
};
